import ApiIndex from './Index'
import ApiNotDownloaded from './notDownloaded/Index'

export default [
  {
    path: '/api',
    name: 'api',
    component: ApiIndex,
    redirect: '/api/notDownloaded',
    meta: {
      auth: true,
      permission: 'view',
    },
    children: [
      {
        path: 'notDownloaded',
        name: 'apiNotDownloaded',
        component: ApiNotDownloaded,
      },
    ],
  },
]
